const MEROWEN_RETURN_REFUND_TAG = 'merowen-return-refund-page';

class MerowenReturnRefundPage extends HTMLElement {
  constructor() {
    super();
    this.handleDirectoryClick = this.handleDirectoryClick.bind(this);
    this.handleFieldInvalid = this.handleFieldInvalid.bind(this);
    this.handleFieldInput = this.handleFieldInput.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.updateMessageCounter = this.updateMessageCounter.bind(this);
  }

  connectedCallback() {
    if (this.dataset.merowenReturnRefundReady === 'true') return;

    this.dataset.merowenReturnRefundReady = 'true';
    this.addEventListener('click', this.handleDirectoryClick);

    this.form = this.querySelector('.merowen-return-refund__form');
    this.message = this.querySelector('[data-merowen-return-refund-message]');
    this.counter = this.querySelector('[data-merowen-return-refund-counter]');
    this.submitButton = this.querySelector('[data-merowen-return-refund-submit]');

    if (this.form) {
      this.form.addEventListener('invalid', this.handleFieldInvalid, true);
      this.form.addEventListener('input', this.handleFieldInput);
      this.form.addEventListener('change', this.handleFieldInput);
      this.form.addEventListener('submit', this.handleFormSubmit);
    }

    if (this.message && this.counter) this.updateMessageCounter();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleDirectoryClick);
    if (this.form) {
      this.form.removeEventListener('invalid', this.handleFieldInvalid, true);
      this.form.removeEventListener('input', this.handleFieldInput);
      this.form.removeEventListener('change', this.handleFieldInput);
      this.form.removeEventListener('submit', this.handleFormSubmit);
    }
    delete this.dataset.merowenReturnRefundReady;
  }

  updateMessageCounter() {
    if (!this.message || !this.counter) return;
    this.counter.textContent = `${this.message.value.length} / 1000`;
  }

  handleFieldInvalid(event) {
    const field = event.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;

    if (field.type === 'radio') {
      const topicGroup = field.closest('[data-merowen-return-refund-topic-group]');
      const topicError = topicGroup?.querySelector('.merowen-return-refund__field-error');
      if (topicError) topicError.hidden = false;
      topicGroup?.querySelectorAll('input[type="radio"]').forEach((radio) => radio.setAttribute('aria-invalid', 'true'));
      return;
    }

    const errorId = field.dataset.merowenReturnRefundErrorId;
    const error = errorId ? this.querySelector(`[id="${CSS.escape(errorId)}"]`) : null;
    if (error) {
      if (field.type === 'email' && field.validity.typeMismatch) {
        error.textContent = 'Please enter a valid email address.';
      }
      error.hidden = false;
    }
    field.setAttribute('aria-invalid', 'true');
  }

  handleFieldInput(event) {
    const field = event.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;

    if (field === this.message) this.updateMessageCounter();

    if (field.type === 'radio') {
      const topicGroup = field.closest('[data-merowen-return-refund-topic-group]');
      const checked = topicGroup?.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      const topicError = topicGroup.querySelector('.merowen-return-refund__field-error');
      if (topicError) topicError.hidden = true;
      topicGroup.querySelectorAll('input[type="radio"]').forEach((radio) => radio.removeAttribute('aria-invalid'));
      return;
    }

    if (!field.validity.valid) return;
    const errorId = field.dataset.merowenReturnRefundErrorId;
    const error = errorId ? this.querySelector(`[id="${CSS.escape(errorId)}"]`) : null;
    if (error) error.hidden = true;
    field.removeAttribute('aria-invalid');
  }

  handleFormSubmit() {
    if (!this.form?.checkValidity() || !this.submitButton) return;
    this.submitButton.disabled = true;
    this.submitButton.setAttribute('aria-disabled', 'true');
  }

  handleDirectoryClick(event) {
    const link = event.target.closest('.merowen-return-refund__directory-link');
    if (!link || !this.contains(link)) return;
    if (this.dataset.merowenReturnRefundSmoothScroll !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const targetId = decodeURIComponent(link.hash.slice(1));
    const target = [...this.querySelectorAll('[id]')].find((element) => element.id === targetId);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    target.focus({ preventScroll: true });
    window.history.pushState(null, '', link.hash);
  }
}

if (!customElements.get(MEROWEN_RETURN_REFUND_TAG)) {
  customElements.define(MEROWEN_RETURN_REFUND_TAG, MerowenReturnRefundPage);
}
